export default function Footer() {
  return (
    <footer className="footer">
      <div className="containerWide footer__inner">
        <div>
          <div className="footer__brand">Убери</div>
          <div className="muted">Вывоз ненужных вещей на переработку</div>
        </div>
        <div className="footer__links">
          <a href="/uslugi/">Все услуги</a>
          <a href="/goroda/">Города</a>
          <a href="/#contacts">Оставить заявку</a>
        </div>

      </div>

      <div className="footer__bottom">
        <div className="containerWide muted">© {new Date().getFullYear()} • Убери</div>
      </div>
    </footer>
  );
}
